import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from './api/axios';
import i18n from './i18n';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CartProvider } from './context/CartContext';
import { ThemeProvider } from './context/ThemeContext';
import Login from './pages/Login';
import Register from './pages/Register'; // Kayıt Sayfası
import Dashboard from './pages/Dashboard';
import Categories from './pages/admin/Categories';
import Products from './pages/admin/Products';
import ProductAdd from './pages/admin/ProductAdd';
import ProductEdit from './pages/admin/ProductEdit'; // Düzenleme sayfası
import ProductList from './pages/dealer/ProductList';
import ProductDetail from './pages/dealer/ProductDetail'; // Ürün Detay Sayfası
import Cart from './pages/dealer/Cart'; // Sepet sayfası
import AdminOrders from './pages/admin/Orders'; // Admin Siparişleri
import MyOrders from './pages/dealer/MyOrders'; // Bayi Siparişleri
import OrderDetail from './pages/OrderDetail'; // Sipariş Detay Sayfası
import Settings from './pages/admin/Settings'; // Ayarlar Sayfası
import Profile from './pages/dealer/Profile'; // Profil Sayfası
import Reports from './pages/admin/Reports'; // Raporlar Sayfası
import Dealers from './pages/admin/Dealers'; // Bayi Yönetimi Sayfası
import DealerDetail from './pages/admin/DealerDetail'; // Bayi Detay Sayfası
import Favorites from './pages/dealer/Favorites'; // Favorilerim Sayfası

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  // Çevirileri API'den Yükle
  useEffect(() => {
    const loadTranslations = async () => {
      try {
        const res = await axios.get('/translations');
        if (res.data && res.data.resources) {
          i18n.addResourceBundle('tr', 'translation', res.data.resources.tr.translation, true, true);
          i18n.addResourceBundle('fr', 'translation', res.data.resources.fr.translation, true, true);
        }
      } catch (error) {
        console.error('Çeviriler yüklenemedi:', error);
      } finally {
        setIsLoaded(true);
      }
    };
    loadTranslations();
  }, []);

  if (!isLoaded) {
    return <div className="d-flex justify-content-center align-items-center vh-100"><div className="spinner-border text-primary" role="status"></div></div>;
  }

  return (
    <ThemeProvider>
      <CartProvider>
        <Router>
          <div className="App">
            <ToastContainer position="top-right" autoClose={3000} />
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin/categories" element={<Categories />} />
              <Route path="/admin/products" element={<Products />} />
              <Route path="/admin/products/new" element={<ProductAdd />} />
              <Route path="/admin/products/edit/:id" element={<ProductEdit />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/admin/settings" element={<Settings />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/admin/reports" element={<Reports />} />
              <Route path="/admin/dealers" element={<Dealers />} />
              <Route path="/admin/dealers/:id" element={<DealerDetail />} />
              <Route path="/favorites" element={<Favorites />} />
            </Routes>
          </div>
        </Router>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
